var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button-pulldown',{staticClass:"select-pulldown-button",on:{"click":_vm.clickEvent}},[_c('div',{staticClass:"select-pulldown-button__text text-weight-bold"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }